import type { FeatureFlagConfig } from './types';

export function isFlagOnForEnvironment(config: FeatureFlagConfig) {
  return config.on;
}
